export default {
    login_register: 'Најава/Регистрација',
    booking_confirmation_title: 'Потврда на резервација',
    booking_confirmation_body: 'Ви благодариме за вашата резервација. Деталите за потврдата се подолу.',
    insurance_requirements_modal_disclaimer: `Со правење на оваа резервација, потврдувам дека: немам осудителни пресуди или сообраќајни прекршоци во последните 5 години. Не ми е одбиена понуда, не ми е откажана полиса или одбиено обновување, ниту сум бил/а побаран/а да платам зголемена премија или да ми бидат наметнати посебни услови од било кој осигурител. Не сум дисквалификуван/а од возење. Немам покренато судски постапки или полициска истрага. Немам пресуди за кражба, измама или нечесност во последните 5 години. Не страдам од оштетен вид или слух (што не е коригирано со очила или слушен апарат), срцеви заболувања, дијабетес, напади или било каква физичка или ментална попреченост. Немам имано несреќи во последните 5 години. Кликнете {0} ако не ги исполнувате овие услови.`,
    insurance_requirements_here: 'овде',
    insurance_requirements: 'Ги прочитав и разбрав {0}',
    ir: 'Осигурителни услови',
    location: 'Локација',
    pickup_location: 'Локација на подигнување',
    dropoff_location: 'Локација на враќање',
    vehicle: 'Возило',
    pickup_and_dropoff: 'Подигнување и враќање (локално време)',
    view_voucher: 'Види ваучер',
    identity_verification_body: 'Ќе треба да ја потврдите вашата идентификација пред да го подигнете возилото',
    identity_verification_title: 'Потврда на идентитет',
    search_again: 'Пребарај повторно',
    refrigerated: 'ладено',
    aircon_lower: 'клима',
    aircon: 'Клима уред',
    refrigeration: 'Ладено',
    not_available: 'Drive & Go моментално е достапен само за лица со документи за идентификација и возачка дозвола од следните земји.',
    check_if_included: 'Проверете дали вашата земја е вклучена.',
    included_in_booking: 'Вклучено во оваа резервација',
    cdw_with_excess: 'CDW со учество',
    theft_protection: 'Заштита од кражба со учество',
    risk_reduction: 'Намалување на ризик',
    free_extras: 'Со оваа резервација добивате право на два бесплатни додатоци <br />.',
    continue: 'Продолжи',
    luggage_large_short_label: 'Г',
    luggage_medium_short_label: 'С',
    luggage_small_short_label: 'М',
    luggage_large_long_label: 'голем',
    luggage_medium_long_label: 'среден',
    luggage_small_long_label: 'мал',
    fuel_unspecified_label: 'неодредено',
    transmission_manual_label: 'Рачен',
    transmission_automatic_label: 'Автоматски',
    make_a_booking: 'Резервирај',
    pickup_date: 'Датум на подигнување',
    dropoff_date: 'Датум на враќање',
    driver_age: 'Возач помеѓу 30 - 65',
    enter_driver_age: 'Внесете возраст на возачот',
    promo_code: 'Промо код',
    search: 'Пребарај',
    dropoff_date_cannot_be_before_pickup_date: 'Датумот на враќање не може да биде пред датумот на подигнување',
    pickup_date_cannot_be_in_the_past: 'Датумот на подигнување не може да биде во минатото',
    pickup_time_cannot_be_in_the_past: 'Времето на подигнување не може да биде во минатото',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Времето на враќање мора да биде подоцна од времето на подигнување ако е истиот ден',
    vehicle_filters: 'Филтри за возила',
    reset: 'Ресетирај',
    transmission: 'Менувач',
    all: 'Сите',
    manual: 'Рачен',
    auto: 'Автоматски',
    passengers: 'Патници',
    vehicle_type: 'Тип на возило',
    filter: 'Филтрирај',
    vehicle_search: 'Пребарување на возила',
    edit: 'Уреди',
    no_results: 'Нема резултати според вашите филтри.',
    small_cars: 'Мали автомобили',
    medium_cars: 'Средни автомобили',
    large_cars: 'Големи автомобили',
    estate_cars: 'Каравани',
    suvs: 'SUV',
    mpvs: 'MPV',
    vans: 'Комбиња',
    camper_vans: 'Кампери',
    premium: 'Премиум',
    unspecified: 'неодредено',
    large: 'голем',
    medium: 'среден',
    small: 'мал',
    automatic: 'автоматски',
    you_have_been_refunded: 'Ви е извршен поврат на средства.',
    please_customer_service: 'За резервација контактирајте ја нашата корисничка поддршка.',
    contact_customer_service: 'Контактирајте корисничка поддршка',
    booking_failed: 'Вашата резервација не може да се обработи во моментов.',
    summary: 'Резиме',
    reforestation_and_protection: 'Поддржете пошумување и заштита на дождовните шуми низ цела Костарика',
    cost_of_rental: 'Цена на наем',
    to_pay_now: 'За плаќање сега',
    greenheart_donation: 'Green Heart донација',
    total_cost: 'Вкупна цена на наем',
    tc_agreement: 'Ги прочитав и разбрав {0}.',
    tc: 'Услови и правила',
    receive_offers: 'Сакам да добивам специјални понуди по е-пошта.',
    donate: 'Да, сакам да донирам {amount}',
    pay_now: 'Плати {amount} сега',
    driver_details: 'Детали за возачот',
    complete_driver_details: 'Ве молиме пополнете ги деталите за возачот.',
    are_you_the_driver: 'Дали сте вие возачот?',
    have_an_account: 'Веќе имате сметка?',
    login: 'Најава',
    or: 'или',
    first_name: 'Име на возачот',
    last_name: 'Презиме на возачот',
    email: 'Е-пошта',
    phone_number: 'Мобилен телефон',
    unable_to_save_driver_information: 'Не може да се зачуваат деталите за возачот. Обидете се повторно.',
    pay_online_now: 'Плати сега',
    day: 'Ден',
    choose_location: 'Изберете локација',
    location_not_found: 'За жал, не ја најдовме бараната локација.',
    add: 'Додај',
    remove: 'Отстрани',
    free_extra: 'Бесплатен додаток',
    free: 'БЕСПЛАТНО!',
    fast_track_notice: 'Ограничувања за потекло на документи важат за оваа услуга. Достапно само за лица со документи од',
    complete_booking: 'Заврши резервација',
    choose_card: 'Изберете картичка или додадете нова.',
    add_billing_details: 'Додадете детали за наплата.',
    card_number: 'Број на картичка',
    card_holder_name: 'Име на сопственикот на картичката',
    card_exp: 'MM / ГГ',
    card_cvc: 'CVC',
    save_card: 'Зачувај картичка?',
    amount_charged: 'Вашата картичка ќе биде задолжена',
    payment_confirmation: 'Потврди резервација и плати',
    payment_methods: 'достапни начини на плаќање',
    use_saved_card: 'x користи зачувана картичка',
    use_different_card: '+ користи друга картичка',
    book_now: 'Резервирај сега',
    minimum_age: 'Само за над {age} години',
    excess_liability: 'Учество',
    security_deposit: 'Депозит',
    fuel_policy: 'Политика за гориво',
    like_for_like: 'Исто за исто',
    full_to_full: 'Полн до полн',
    miles_per_rental: '{mileage} бесплатни милји по наем',
    km_per_rental: '{mileage} бесплатни км по наем',
    unlimited_mileage: 'Неограничена километража',
    unlimited_mileage_km: 'Неограничени километри',
    non_amendable: 'Не може да се менува',
    non_refundable: 'Не се враќа',
    free_cancellation_until: 'Бесплатно откажување до',
    cancellation_in_line_with: 'Откажување според',
    tcs: 'Услови и правила',
    free_extras_on_collection: 'Два бесплатни додатоци при подигнување',
    glass_and_tyres_covered: 'Стакла и гуми покриени',
    number_of_passengers: 'Број на патници',
    number_of_bags: 'Број на торби',
    fuel_type: 'Тип на гориво',
    co2: 'CO2',
    book_type: 'Резервирај {type}',
    processing: 'Обработка',
    actual_price: 'Вистинска цена',
    tooltip: 'Цената во {currencyCode} е проценка според курсот, цената во {currency} е обврзувачка.',
    deposit: 'Депозит',
    pay_online: 'Плати сега',
    pay_online_without_extras: 'Цена на наем',
    extras_on_arrival: 'Додатоци при пристигнување',
    insurance_on_arrival: 'Намалување на ризик - плати при пристигнување',
    insurance_online: 'Намалување на ризик - плати сега',
    extras_online: 'Додатоци - плати сега',
    green_heart_donation: 'Green Heart донација',
    why_use_drive_and_go: 'Зошто да користите Drive & Go?',
    straight_to_car: 'Директно до возилото',
    no_queues: 'Без редици',
    self_checkout: 'Самопослужување',
    cant_lose_key: 'Клучот не може да се изгуби',
    online_id_check: 'Онлајн проверка на идентитет',
    phone_as_key: 'Телефон како клуч',
    premiumplus_benefits_includes: 'Вклучени и Premium Plus+ бенефиции',
    book_drive_go: 'Резервирај Drive & Go',
    distance_allowance: 'Дозволена дистанца',
    duration: 'Траење',
    view_more_bookings: 'Види повеќе резервации',
    to_pay_on_arrival: 'За плаќање при пристигнување',
    pay_on_arrival: 'Плати при пристигнување',
    unlimited: 'Неограничено',
    return_date: 'Датум на враќање',
    postcode: 'Поштенски код',
    country: 'Држава',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go моментално е достапен само за лица со документи за идентификација и возачка дозвола од следните земји:',
        drive_and_go_today: 'Drive & Go резервација за денес!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Зошто да користите Drive & Go?',
        straight_to_car: 'Директно до возилото',
        no_queues: 'Без редици',
        self_checkout: 'Самопослужување',
        cannot_lose_the_key: 'Клучот не може да се изгуби',
        online_id_check: 'Онлајн проверка на идентитет',
        phone_as_a_key: 'Телефон како клуч',
        premium_plus_benefits_also_included: 'Вклучени и Premium Plus+ бенефиции',
        book_drive_and_go: 'Резервирај Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Шатор и опрема',
        quick_and_easy: 'Брзо и лесно поставување',
        travel_freedom: 'Слобода на патување',
        affordable_campervan_alternative: 'Достапна алтернатива на камперот',
        lightweight_and_compact: 'Лесно и компактно',
        fully_insured: 'Целосно осигурано',
    },
    my_bookings: 'Моја резервација',
    no_bookings: 'Нема резервации',
    my_profile: 'Мој профил',
    no_bookings_to_display: 'Нема резервации за прикажување.',
    search_great_car_rental_deals: 'Пребарај одлични понуди за изнајмување автомобили за вашето следно патување.',
    odometer_at_collection: 'Бројач на километри при подигнување',
    fuel_at_collection: 'Гориво при подигнување',
    start_check_in: 'Започни пријава',
    start_collection: 'Започни подигнување',
    recent_bookings: 'Последна резервација',
    damage: {
        updated_damage_report_submitted: 'Ажуриран извештај за оштетување е поднесен. Нашиот тим за корисничка поддршка ќе ве контактира доколку е потребно.',
        add_additional_damage: 'Додај дополнително оштетување',
        you_may_report_additional_damage_up_to: 'Може да пријавите дополнително оштетување до 24 часа по враќањето на возилото',
        specify_damage: 'Наведете оштетување',
        please_choose_the_area_and_type_of_damage: 'Изберете област и тип на оштетување',
        type_of_damage: 'Тип на оштетување',
        is_this_more_than_5_cm: 'Дали е ова повеќе од 5 см?',
        please_take_or_select_a_photo: 'Сликајте или изберете фотографија',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Сликајте така што оштетувањето ќе биде јасно видливо',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Доколку е потребно, можете да додадете уште една фотографија, изберете ја иконата за додавање',
        save_image: 'Зачувај слика',
        save_images: 'Зачувај слики',
        damage_saved_successfully: 'Оштетувањето е успешно зачувано',
        add_photo: 'Додај фотографија',
    },
    checkout: {
        start_collection: 'Започни подигнување',
        collect_vehicle: 'Подигни возило',
        we_will_let_you_know_the_details: 'Ќе ве известиме за локацијата и деталите за да го најдете изнајменото возило.',
        inspect: 'Провери',
        we_will_ask_for_four_photos_from_each_corner: 'Ќе побараме четири фотографии од секој агол на возилото и сите нови оштетувања кои не се веќе наведени.',
        fuel_and_milage: 'Гориво и километража',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Ги потврдувате бројачот на километри и горивото на почетокот на изнајмувањето.',
        sign: 'Потпиши',
        sign_the_rental_agreement: 'Потпиши договор за наем.',
        away_you_go: 'Среќен пат',
        you_are_free_to_take_to_the_road: 'Слободно тргнете на пат!',
        collect_your_vehicle: 'Подигнете го вашето возило',
        get_directions: 'Добиј насоки',
        hide_directions: 'Скриј насоки',
        local_time: 'локално време',
        tel: 'Тел',
        getting_to_the_location: 'Како да стигнете до локацијата',
        get_vehicle_details: 'Детали за возилото',
        view_map: 'Види мапа',
        unlock_vehicle_and_continue: 'Отклучи возило и продолжи',
        unable_to_connect_to_vehicle: 'Не може да се поврзе со возилото',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Не можевме да се поврземе со возилото – проверете дали сте до вистинското возило и обидете се повторно.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Не можевме да ја најдеме резервацијата за возилото. Обидете се подоцна.',
        odometer_and_fuel: 'Бројач на километри и гориво',
        odometer: 'Бројач на километри',
        please_confirm_the_odometer_and_fuel_readings: 'Доколку е можно, потврдете ги бројачот на километри и горивото.',
        the_odometer_field_is_required: 'Полето за бројач на километри е задолжително',
        and_must_be_greater_than_the_checkout_odometer: 'и мора да биде поголемо од бројачот на километри при подигнување',
        confirm: 'Потврди',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Сликајте од секој агол на возилото',
        pre_existing_damage: 'Постоечко оштетување',
        no_pre_existing_damage: 'Нема постоечко оштетување.',
        new_damage: 'Ново оштетување',
        add_additional_damage: 'додај дополнително оштетување',
        no_new_damage_to_report: 'Нема ново оштетување за пријавување',
        checkout_complete: 'Подигнувањето е завршено',
        start_rental: 'Започни наем',
        congratulations_name_it_is_time_to_take_to_the_road: 'Честитки {customer_name}, време е да тргнете на пат!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Не можеме да го завршиме подигнувањето на возилото.',
        please_do_the_following: 'Ве молиме направете го следново',
        remove_all_belonging_and_lock_the_vehicle: 'Отстранете ги сите работи и заклучете го возилото.',
        lock_vehicle: 'Заклучи возило',
        once_you_have_contacted_customer_services: 'Откако ќе ја контактирате корисничката поддршка',
        vehicle_location: 'Локација на возилото',
        collect_your: 'Подигнете го вашиот',
        from: 'Од',
        key_in_glove_box: 'клучот се наоѓа во преградата за ракавици',

        keyholder: {
            not_detected: 'Клучот не е детектиран во држачот',
            not_detected_please_try_again: 'Ставете го клучот во држачот и обидете се повторно.',

            not_installed: 'Држачот за клуч не е инсталиран',
            not_installed_please_contact_customer_service: 'Држачот за клуч не е инсталиран, контактирајте ја корисничката поддршка.',
        },
        keyring: {
            look_up_failed: 'Пребарувањето на држачот за клуч не успеа',
            look_up_failed_please_contact_customer_service: 'Пребарувањето на држачот за клуч не успеа, контактирајте ја корисничката поддршка.',
        },
        key: {
            invalid: 'Клучот не е валиден',
            invalid_please_contact_customer_service: 'Вашиот клуч не е валиден, контактирајте ја корисничката поддршка.',

            expired: 'Клучот е истечен',
            expired__please_contact_customer_service: 'Вашиот клуч е истечен, контактирајте ја корисничката поддршка.',
        },
    },
    checkin: {
        start_check_in: 'Започни пријава',
        vehicle_location: 'Локација на возилото',
        tell_us_where_you_have_parked: 'Кажете ни каде го паркиравте возилото.',
        fuel_and_milage: 'Гориво и километража',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Ги потврдувате бројачот на километри и горивото на крајот од изнајмувањето.',
        inspect: 'Провери',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage:
            'Ќе побараме четири фотографии од секој агол на возилото и сите нови оштетувања настанати за време на изнајмувањето.',
        lock: 'Заклучи',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Проверете дали не сте оставиле ништо, потоа заклучете го возилото.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Кажете ни каде го паркиравте возилото',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Откако ќе го заклучите возилото, нема да можете повторно да го отклучите.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, проверете дали не сте оставиле ништо, заклучете го возилото и ако е потребно, вратете го физичкиот клуч во држачот.',
        lock_vehicle: 'Заклучи возило',
        complete_check_in: 'Заврши пријава',
        inspection: 'Инспекција',
        complete_vehicle_check_in: 'Заврши пријава на возилото',
        we_are_unable_to_complete_your_vehicle_check_in: 'Не можеме да ја завршиме пријавата на возилото.',
        please_contact_customer_services: 'Контактирајте ја корисничката поддршка',
        once_you_have_contacted_customer_services: 'Откако ќе ја контактирате корисничката поддршка',
        please_amend_odometer_to_be_greater_than: 'Променете го бројачот на километри на повеќе од {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Договор за наем',
        agreement_between: 'Договор помеѓу',
        and: 'и',
        sign_rental_agreement: 'Потпиши договор за наем',
        i_have_read_and_understood_the_terms_and_conditions: 'Ги прочитав и разбрав условите и ја прифаќам состојбата на возилото',
    },
    additional_options: 'Дополнителни опции',
    booking_details: 'Детали за резервацијата',
    price_for_x_days: 'Цена за {qty_of_days} ден | Цена за {qty_of_days} дена',
    cancelled: 'Откажано',
    upcoming: 'Надојдено',
    active: 'Активно',
    full_insurance_no_deposit: 'Целосно осигурување и без депозит',
    excess: '{amount} учество',
    deposit: '{amount} депозит',
    included_daily_distance: '{distance} {unit} на ден',
    miles: 'мили',
    kilometers: 'километри',
    collection_details_title: 'Детали за подигнување',
    collection_details_not_found: 'Нема дефинирани детали за подигнување за оваа локација',
    free_cancellation: 'Бесплатно откажување',
    no_deposit: 'Без депозит',
    benefit_from: 'Искористете',
    for_only_per_day: 'Само за {price} на ден',
    upgrade_mee: 'UpgradeMee',
};
